<template>
  <div>
    <!-- Contract controls -->
    <b-row
      class="d-flex justify-content-between align-items-center bg-light py-3"
    >
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.contract.actived"
          >Escritura</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.contract.situation"
          :options="contractSituationOptions"
          v-if="proposal.steps.contract.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.contract.status"
          v-if="contractStatusOptions[proposal.steps.contract.situation]"
          :options="contractStatusOptions[proposal.steps.contract.situation]"
        ></b-form-select>
        <br />
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.contract.dueDate"
          v-if="proposal.steps.contract.status"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheContractFlow",
  data() {
    return {
      array: "",
      /*showPendingFgtsDialog: false,*/
      contractSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em análise de conformidade",
          text: "Em análise de conformidade",
          color: "secondary",
          msg: "",
          progress: 0,
        },
        {
          value: "Emitida",
          text: "Emitida",
          color: "light",
          msg: "",
          progress: 0,
        },
      ],
      contractStatusOptions: {
        "Em análise de conformidade": [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Enviando",
            text: "Enviando",
            color: "secondary",
            msg: "Dossiê em montagem no SICTD em",
            progress: 4,
          },
          {
            value: "Enviado",
            text: "Enviado",
            color: "warning",
            msg: "Proposta em análise da conformidade em",
            progress: 6,
          },
          {
            value: "Conforme",
            text: "Conforme",
            color: "primary",
            msg: "Proposta conforme para emissão da escritura em",
            progress: 10,
          },
          {
            value: "Com exigência",
            text: "Com exigência",
            color: "danger",
            msg: "Proposta em cumprimento de exigência(s) em ",
            progress: 4,
          },
          {
            value: "Reenviada",
            text: "Reenviada",
            color: "info",
            msg: "Proposta reeviada para análise da conformidade em",
            progress: 8,
          },
        ],
        Emitida: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Agendada",
            text: "Agendada",
            color: "warning",
            msg: "Escritura agendada para",
            progress: 10,
          },
          {
            value: "Contratada",
            text: "Contratada",
            color: "primary",
            msg: "Escritura contratada em",
            progress: 14,
          },
          {
            value: "Evoluída",
            text: "Evoluída",
            color: "success",
            msg: "Escritura evoluída em",
            progress: 15,
          },
        ],
      },
      selectedProposal: this.$store.state.proposal,
    };
  },
  
  methods: {
    ...mapMutations(["setModificationNotification"]),
  },

  computed: {
    ...mapState(["proposal", "user"]),
    ...mapState("Notification", ["notifications"]),
  },
  watch: {
    "proposal.steps.contract.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.contract.status = "";
      // }
      if (newVal) {
        for (let key in this.contractSituationOptions) {
          if (newVal === this.contractSituationOptions[key].value) {
            this.proposal.steps.contract.color = this.contractSituationOptions[
              key
            ].color;
            this.proposal.steps.contract.note = this.contractSituationOptions[
              key
            ].msg;
            this.proposal.steps.contract[
              "progress"
            ] = this.contractSituationOptions[key].progress;
          }
        }
        if (
          this.proposal.steps.contract.situation != "" &&
          this.proposal.operationValue == 0 &&
          oldVal
        ) {
          this.$bvToast.toast(`Informe o valor da operação da proposta. ;)`, {
            title: "Eiiii... Lembrando!",
            variant: "primary",
            autoHideDelay: 2000,
          });
          //this.$refs.approvedFinancingAmount.$el.focus();
          if (oldVal && !this.proposal.steps.contract.dueDate) {
            var today = new Date();
            var contractDate = moment(today).format("YYYY-MM-DD");
            this.proposal.steps.contract.dueDate = contractDate;
          }
        }
      } else {
        this.proposal.steps.contract.color = "light";
        this.proposal.steps.contract.note = "";
        this.proposal.steps.contract.progress = 0;
      }
    },
    "proposal.steps.contract.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr = this.contractStatusOptions[
          this.proposal.steps.contract.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.contract.color = situation.color;
            if (situation.msg)
              this.proposal.steps.contract.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.contract.progress = situation.progress;
          }
        });
        if (newVal === "Evoluída") {
          bootbox.alert({
            size: "small",
            message: "Please check Operation value",
          });
        }
      } else {
        for (let key in this.contractSituationOptions) {
          if (
            this.proposal.steps.contract.situation ===
            this.contractSituationOptions[key].value
          ) {
            this.proposal.steps.contract.color = this.contractSituationOptions[
              key
            ].color;
            this.proposal.steps.contract.note = this.contractSituationOptions[
              key
            ].msg;
            this.proposal.steps.contract.progress = this.contractSituationOptions[
              key
            ].progress;
          }
        }
      }
      if (
        this.proposal.steps.contract.situation ==
          "Em análise de conformidade" &&
        oldVal &&
        !this.proposal.steps.contract.dueDate
      ) {
        var today = new Date();
        var contractDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.contract.dueDate = contractDate;
      }
    },
    "proposal.steps.contract.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.contract["badgeColor"] = "light";
        this.proposal.steps.contract["color"] = "light";
        this.proposal.steps.contract["dueDate"] = "";
        this.proposal.steps.contract["note"] = "";
        this.proposal.steps.contract["situation"] = "";
        this.proposal.steps.contract["status"] = "";
        this.proposal.steps.contract["progress"] = 0;
      }
    },
    proposal: {
      handler: function(val) {
        if (val.pendingList && val.pendingList.length) {
          this.pendingList = val.pendingList;
        } else if (
          !val.pendingList ||
          (val.pendingList && !val.pendingList.length)
        ) {
          Vue.set(this.proposal, "pendingList", this.pendingList);
        }
        if (val.pendingFgtsList && val.pendingFgtsList.length) {
          this.pendingFgtsList = val.pendingFgtsList;
        } else if (!val.pendingFgtsList) {
          Vue.set(this.proposal, "pendingFgtsList", this.pendingFgtsList);
        }
        if (this.proposal.participants && this.proposal.participants.length) {
          this.proposal.participants.forEach((element) => {
            if (!element.participantList) {
              element.participantList = JSON.parse(
                JSON.stringify(this.participantList)
              );
            }
          });
        }
        if (val.bidderList && val.bidderList.length) {
          this.bidderList = val.bidderList;
        } else if (!val.bidderList) {
          Vue.set(this.proposal, "bidderList", this.bidderList);
        }
      },
      immediate: true,
    },
  },
};
</script>
